import script from "./Shows.vue?vue&type=script&setup=true&lang=js"
export * from "./Shows.vue?vue&type=script&setup=true&lang=js"

import "./Shows.vue?vue&type=style&index=0&id=5a0dccd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0dccd0"]])

export default __exports__